/**
 * /app/{slug}/helpdesk — Helpdesk ticket list with Category / Priority /
 * Sort filter toolbar and "New ticket" CTA.
 *
 * Backend: GET /api/v1/helpdesk/tickets (role-filtered).
 * New-ticket form: POST /api/v1/helpdesk/tickets via /helpdesk/new route.
 */

import { createFileRoute, Link, Outlet, useParams } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { HelpdeskTicketList } from "@/components/helpdesk/helpdesk-ticket-list";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/helpdesk")({
  component: HelpdeskPage,
});

function HelpdeskPage() {
  const { tenantSlug } = useParams({ strict: false }) as {
    tenantSlug: string;
  };
  return (
    <>
      <PageHeader
        title="Helpdesk"
        description="Submit and track IT / HR / Admin tickets."
        actions={
          <Button asChild className="gap-1.5">
            <Link
              to="/app/$tenantSlug/helpdesk/new"
              params={{ tenantSlug }}
            >
              <Plus className="h-4 w-4" />
              New ticket
            </Link>
          </Button>
        }
      />
      <HelpdeskTicketList />
      <Outlet />
    </>
  );
}
